export class StepGuideV1SetupMode {
  constructor (onboarding) {
    this.onboarding = onboarding;
  }

  id = "guide_v1_setup_mode";
  title = "Enable Device";

  template = `
  <div class="onboarding-step" data-for="guide_v1_setup_mode">
    
    <div class="onboarding-guide">
      
      <p class="onboarding-guide-instruction" style="margin-bottom: 0;">
        Insert your batteries and wait for a blue light.  This light should be on or blinking for at least 15 seconds.
      </p>
      
      <img data-for="v1-server-mode" class="onboarding-guide-instruction-image" src="${window.site.home}/../assets/images/setup/v1_server_mode_blue_led.gif" width="245" height="367" />
      
      <p class="onboarding-guide-instruction">
        If the blue light has been on for at least 15 seconds, this indicates the sensor is in setup mode, click "next" below.
      </p>
      
      <div class="onboarding-guide-next">
        <button class="button onboarding-guide-next-btn" data-for="guide_v1_setup_mode_next">
          Next
        </button>
      </div>
      
      <div class="onboarding-guide-help">
        <button class="button button--link onboarding-guide-help-btn" data-for="guide_v1_setup_mode_help">
          Help! The light isn't staying blue.
        </button>
      </div>
      
    </div>
   
    
  </div>
  `;

  onBack = () => {
    this.onboarding.goToStep("guide_select_model");
    this.onboarding.hideBackButton();
  }

  onActivate = () => {
    this.onboarding.sensor_version = 'v1';
    this.onboarding.showBackButton();
  }

  bindActions = () => {

    this.$nextBtn = $(this.onboarding.container).find('button[data-for="guide_v1_setup_mode_next"]');
    this.$nextBtn.on('click', () => {
      this.onboarding.goToConnection();
    });

    this.$helpBtn = $(this.onboarding.container).find('button[data-for="guide_v1_setup_mode_help"]');
    this.$helpBtn.on('click', () => {
      this.onboarding.goToStep("guide_v1_setup_help");
    });

  }

}
